import { hapticFeedback as sdkHaptic } from "@telegram-apps/sdk";
import { SettingsStorageService } from "../services/LocalStorageService";

type ImpactStyle = Parameters<typeof sdkHaptic.impactOccurred>[0];

function impactOccurred(style: ImpactStyle) {
  if (!SettingsStorageService.isHapticsEnabled()) return;
  try {
    if (sdkHaptic.impactOccurred.isAvailable()) {
      sdkHaptic.impactOccurred(style);
    }
  } catch {}
}

impactOccurred.isAvailable = function () {
  try {
    return sdkHaptic.impactOccurred.isAvailable();
  } catch {
    return false;
  }
};

export const hapticFeedback = {
  impactOccurred,
};

export default hapticFeedback;
